module.exports = __webpack_public_path__ + "img/chat.b54d0730.svg";